<header role="banner" class="form-input__header">
  <div class="form-input__header__container">
    <p *ngIf="question.title" class="form-input__header__container__title" [innerHTML]="title"></p>
    <app-tooltip *ngIf="question.tooltip">
      <p class="form-input__header__container__tooltip" [innerHTML]="tooltip"></p
    ></app-tooltip>
  </div>
  <p *ngIf="question.subtitle" class="form-input__header__subtitle" [innerHTML]="subtitle"></p>
</header>

<mat-form-field class="form-input__field form-input__field--text">
  <mat-label>{{ label || 'Votre réponse' }}</mat-label>
  <input
    #input
    type="text"
    [id]="elm_id"
    [name]="elm_id"
    [formControl]="control"
    [placeholder]="placeholder"
    [required]="required"
    matInput
    (keyup.enter)="next(control)"
  />

  <mat-error *ngIf="control?.errors?.required">
    {{ errorMsg || 'Veuillez sélectionner une valeur' }}
  </mat-error>
  <mat-error *ngIf="control?.errors?.email"> Votre adresse e-mail est incorrecte </mat-error>
  <mat-error *ngIf="control?.errors?.phone"> Votre numéro de téléphone est invalide </mat-error>
  <mat-error *ngIf="control?.errors?.siret"> Votre numéro de SIRET est invalide </mat-error>
  <mat-error *ngIf="control?.errors?.siretAlreadyExist"> Ce SIRET est déjà utilisé par une entreprise</mat-error>
  <mat-error *ngIf="control?.errors?.pattern"> La valeur saisie n'est pas au bon format </mat-error>
</mat-form-field>

<footer class="form-input__actions">
  <button
    class="btn"
    type="button"
    (click)="next(control)"
    [attr.aria-label]="'Valider la question: ' + question.ariaLabel"
  >
    {{ btnLabel ?? 'Valider' }}
  </button>
  <button
    *ngIf="!required"
    class="btn-clean"
    type="button"
    (click)="skipQuestion.emit(control)"
    [attr.aria-label]="'Passer la question: ' + question.ariaLabel"
  >
    Passer
  </button>
</footer>
